'use strict';

exports.__esModule = true;
exports.isEvent = exports.hasCustomRenderer = exports.getComponent = exports.isFunction = exports.composeThemeObject = exports.connect = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactRedux = require('react-redux');

var _reactivecore = require('@appbaseio/reactivecore');

var connect = exports.connect = function connect() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _reactRedux.connect.apply(undefined, args.concat([null, {
    storeKey: _reactivecore.storeKey
  }]));
};

var composeThemeObject = exports.composeThemeObject = function composeThemeObject() {
  var ownTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    typography: _extends({}, ownTheme.typography, userTheme.typography),
    colors: _extends({}, ownTheme.colors, userTheme.colors),
    component: _extends({}, ownTheme.component, userTheme.component)
  };
};
/**
 * To determine wether an element is a function
 * @param {any} element
 */


var isFunction = exports.isFunction = function isFunction(element) {
  return typeof element === 'function';
};
/**
 * Extracts the render prop from props and returns a valid React element
 * @param {Object} data
 * @param {Object} props
 */


var getComponent = exports.getComponent = function getComponent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var children = props.children,
      render = props.render; // Render function as child

  if (isFunction(children)) {
    return children(data);
  } // Render function as render prop


  if (isFunction(render)) {
    return render(data);
  }

  return null;
};
/**
 * To determine whether a component has render prop defined or not
 * @returns {Boolean}
 */


var hasCustomRenderer = exports.hasCustomRenderer = function hasCustomRenderer() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var render = props.render,
      children = props.children;
  return isFunction(children) || isFunction(render);
};

var isEvent = exports.isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};